import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import ServiceDropdown from './ServiceDropdown';
import ValueField from './ValueField';
import Checkbox from './Checkbox';

const ServiceDescription = styled.div`
    margin: 1rem 0 !important;
`;

const SelectionRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

export default class ApplicationItem extends React.Component {
    state = {
        serviceDropdownOpened: false,
        selectedService: null,
        value: 0,
        amount: 0,
        childServices: [],
    };

    render() {
        const {
            selectedService,
            value,
            amount,
            serviceDropdownOpened,
        } = this.state;
        const { services, showRemoveButton, onRemove, item } = this.props;

        return (
            <div>
                <SelectionRow>
                    <ServiceDropdown
                        items={services.filter((item) => item.primary)}
                        opened={serviceDropdownOpened}
                        selectedItem={selectedService}
                        onClick={this.handleServiceDropdownClick}
                        onSelect={this.handleSelectService}
                    />
                    {showRemoveButton && (
                        <button
                            className="delete"
                            onClick={() => onRemove(item)}
                        />
                    )}
                </SelectionRow>
                {selectedService && (
                    <div>
                        <ServiceDescription>
                            <div className="notification">
                                <FormattedMessage
                                    id={`exhibitApplication.services.${
                                        selectedService.name
                                    }.description`}
                                    tagName="p"
                                />
                            </div>
                        </ServiceDescription>
                        <ValueField
                            value={value}
                            onChange={this.handleValueChange}
                            unit={selectedService.unit}
                            price={selectedService.price}
                            amount={amount}
                        />
                        {selectedService.services &&
                            selectedService.services.map(
                                this.renderChildService
                            )}
                    </div>
                )}
            </div>
        );
    }

    initChildServices = (service) => {
        if (!service.services) {
            return [];
        }
        const childServices = this.props.services
            .filter(
                (item) => service.services.filter((i) => i === item.name).length
            )
            .map((item) => ({
                ...item,
                value: item.minValue,
                amount: item.minValue * item.price,
                selected: false,
            }));
        return childServices;
    };

    renderChildService = (childServiceName) => {
        const childService = this.state.childServices.find(
            (item) => (item.name = childServiceName)
        );
        const { selected, value, amount, unit, price } = childService;

        return (
            <div key={childServiceName} style={{ marginTop: '1rem' }}>
                <Checkbox
                    selected={selected}
                    onChange={() =>
                        this.handleChildServiceSelectChange(childService)
                    }
                    messageId={`exhibitApplication.services.${childServiceName}.title`}
                    style={{ marginBottom: selected ? '0.5rem' : 0 }}
                />
                {selected && (
                    <ValueField
                        value={value}
                        onChange={(event) =>
                            this.handleChildServiceValueChange(
                                event,
                                childService
                            )
                        }
                        unit={unit}
                        price={price}
                        amount={amount}
                    />
                )}
            </div>
        );
    };

    handleServiceDropdownClick = () => {
        this.setState({
            serviceDropdownOpened: !this.state.serviceDropdownOpened,
        });
    };

    handleSelectService = (event) => {
        const selectedService = this.props.services.find(
            (item) => item.name === event.currentTarget.dataset.name
        );
        if (
            this.state.selectedService &&
            selectedService.name === this.state.selectedService.name
        ) {
            this.setState({
                serviceDropdownOpened: false,
            });
            return;
        }
        this.setState(
            {
                selectedService,
                value: selectedService.minValue,
                amount: selectedService.price * selectedService.minValue,
                serviceDropdownOpened: false,
                childServices: this.initChildServices(selectedService),
            },
            this.onChange
        );
    };

    handleValueChange = (event) => {
        const value = Number(event.currentTarget.value);
        const { selectedService } = this.state;
        const newValue =
            value < selectedService.minValue ? selectedService.minValue : value;
        this.setState(
            {
                value: newValue,
                amount: selectedService.price * newValue,
                childServices: this.recalculateChildServices(newValue),
            },
            this.onChange
        );
    };

    handleChildServiceSelectChange = (service) => {
        const { childServices } = this.state;
        this.setState(
            {
                childServices: childServices.map(
                    (item) =>
                        item.name === service.name
                            ? { ...item, selected: !service.selected }
                            : item
                ),
            },
            this.onChange
        );
    };

    handleChildServiceValueChange = (event, service) => {
        const { childServices, value: applicationValue } = this.state;
        const value = Number(event.currentTarget.value);
        const newValue = this.getChildServiceValue(
            value,
            applicationValue,
            service
        );
        this.setState(
            {
                childServices: childServices.map(
                    (item) =>
                        item.name === service.name
                            ? {
                                  ...item,
                                  value: newValue,
                                  amount: newValue * service.price,
                              }
                            : item
                ),
            },
            this.onChange
        );
    };

    getChildServiceValue = (value, applicationValue, service) => {
        return service.minValue && value < service.minValue
            ? service.minValue
            : service.maxValue && value > applicationValue
                ? applicationValue
                : value;
    };

    recalculateChildServices = (applicationValue) => {
        return this.state.childServices.map((service) => {
            if (!service.selected && !service.recalculate) {
                return service;
            }
            const newValue = this.getChildServiceValue(
                service.value,
                applicationValue,
                service
            );
            return {
                ...service,
                value: newValue,
                amount: newValue * service.price,
            };
        });
    };

    onChange = () => {
        const { selectedService, childServices, value, amount } = this.state;
        this.props.onChange(this.props.item, {
            name: selectedService.name,
            price: selectedService.price,
            unit: selectedService.unit,
            value,
            amount,
            childServices: childServices.filter((item) => item.selected),
        });
    };
}



// WEBPACK FOOTER //
// ./src/components/ContactForm/components/ApplicationItem.js